import React from 'react'

import s from './style.module.scss'

class Squiggle extends React.Component {
  render() {
    const origin = {
      //origin of axes
      x: 0,
      y: 0
    }
    const amplitude = 8 // wave amplitude
    const rarity = 1 // point spacing
    const freq = 0.175 // angular frequency
    const phase = 20 // phase angle
    const stroke_width = 1.5
    const svg_height = this.props.height || 1000
    const stroke_color = this.props.strokeColor || 'white'

    const lines = []

    for (let i = 0; i < svg_height; i++) {
      lines.push(
        <line
          y1={(i - 1) * rarity + origin.x}
          x1={
            Math.sin(freq * (i - 1 + phase)) * amplitude +
            amplitude +
            stroke_width / 2
          }
          y2={i * rarity + origin.x}
          x2={
            Math.sin(freq * (i + phase)) * amplitude +
            amplitude +
            stroke_width / 2
          }
          key={i}
        />
      )
    }

    return (
      <div className={s.squiggle}>
        <svg
          width={amplitude * 2 + stroke_width * 2}
          height={svg_height}
          strokeWidth={stroke_width}
          stroke={stroke_color}>
          {lines}
        </svg>
      </div>
    )
  }
}

export default Squiggle



// WEBPACK FOOTER //
// ./src/components/squiggle/index.js